import { render } from "./Archive_items.vue?vue&type=template&id=1bd405b1"
import script from "./Archive_items.vue?vue&type=script&lang=js"
export * from "./Archive_items.vue?vue&type=script&lang=js"
script.render = render

export default script